import axios from "axios";
import { API_URL } from "../config/env";
import { getHeaders, processError } from "../helpers/service-helper";

/**
 *
 * @returns {Promise<object[]>}
 */
export const selectAreas = async () => {
    try {
        const resp = await axios.get(`${API_URL}/areas/select`, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const selectAreasPorSede = async (sedeId) => {
    try {
        const resp = await axios.get(`${API_URL}/areas/sede/${sedeId}`, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const selectTipoSolicitudPorArea = async (areaId) => {
    try {
        const resp = await axios.get(`${API_URL}/areas/tipoSolicitud/${areaId}`, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const obtenerSubAreasPorSede = async (sedesIds = []) => {
    try {
        const resp = await axios.post(
            `${API_URL}/subareas/sedes`,
            { sedes: sedesIds },
            {
                headers: getHeaders(),
            }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const obtenerSubAreasPorSedesYPersona = async (sedesIds = [], $id_persona) => {
    try {
        const resp = await axios.post(
            `${API_URL}/subareas/${$id_persona}/sedes`,
            { sedes: sedesIds, id_persona: $id_persona },
            {
                headers: getHeaders(),
            }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const obtenerPersonaHasSubAreas = async (idPersona) => {
    try {
        const resp = await axios.get(`${API_URL}/subareas/${idPersona}`, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};
